function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Conviva } from '@sky-uk-ott/core-video-sdk-js-external-conviva';
import { checkIsManifestLinearType } from '../../../../utils/playback-type';
import { sdkLogger } from '../../../../logger';
import { VideoStartupStates } from '../../../../core/session-controller/video-startup/video-startup-states';
import { ContentDescriptorEnum, getAssetEncodingTag, getContentDescriptor } from '../../shared/asset-info';
import { ReportingPrefetchStage } from './conviva-addon-proposition.enums';
export { ReportingPrefetchStage } from './conviva-addon-proposition.enums';
export var ConvivaTagsProvider = /*#__PURE__*/ function() {
    "use strict";
    function ConvivaTagsProvider() {
        _class_call_check(this, ConvivaTagsProvider);
        _define_property(this, "logger", sdkLogger.withContext('ConvivaTagsProvider'));
        _define_property(this, "convivaAddonInfo", void 0);
        _define_property(this, "playoutData", void 0);
        _define_property(this, "sessionItem", void 0);
    }
    _create_class(ConvivaTagsProvider, [
        {
            key: "updateContentData",
            value: function updateContentData(contentData) {
                var convivaAddonInfo = contentData.convivaAddonInfo, sessionItem = contentData.sessionItem, playoutData = contentData.playoutData;
                if (sessionItem && this.sessionItem !== sessionItem) {
                    this.sessionItem = sessionItem;
                }
                if (this.playoutData !== playoutData) {
                    this.playoutData = playoutData;
                }
                if (convivaAddonInfo && this.convivaAddonInfo !== convivaAddonInfo) {
                    this.convivaAddonInfo = convivaAddonInfo;
                }
            }
        },
        {
            key: "getAdName",
            value: function getAdName(ad) {
                return ad.name;
            }
        },
        {
            key: "getAdDuration",
            value: function getAdDuration(ad) {
                return ad.expectedDuration;
            }
        },
        {
            key: "getIsLive",
            value: function getIsLive() {
                return this.sessionItem && checkIsManifestLinearType(this.sessionItem.type) ? Conviva.Constants.StreamType.LIVE : Conviva.Constants.StreamType.VOD;
            }
        },
        {
            key: "getStreamLen",
            value: function getStreamLen() {
                var _this_playoutData_durationMs, _this_playoutData;
                return (this.playoutData && checkIsManifestLinearType(this.playoutData.type) ? '' : (_this_playoutData = this.playoutData) === null || _this_playoutData === void 0 ? void 0 : (_this_playoutData_durationMs = _this_playoutData.durationMs) === null || _this_playoutData_durationMs === void 0 ? void 0 : _this_playoutData_durationMs.toString()) || '';
            }
        },
        {
            key: "getStreamUrl",
            value: function getStreamUrl() {
                var _this_playoutData_cdns_, _this_playoutData;
                return ((_this_playoutData = this.playoutData) === null || _this_playoutData === void 0 ? void 0 : (_this_playoutData_cdns_ = _this_playoutData.cdns[0]) === null || _this_playoutData_cdns_ === void 0 ? void 0 : _this_playoutData_cdns_.url.substring(0, Conviva.Constants.MAXIMUM_URL_LENGTH)) || '';
            }
        },
        {
            key: "getViewerId",
            value: function getViewerId() {
                var _this_sessionItem_user_ids_conviva, _this_sessionItem_user_ids, _this_sessionItem_user, _this_sessionItem;
                return (_this_sessionItem = this.sessionItem) === null || _this_sessionItem === void 0 ? void 0 : (_this_sessionItem_user = _this_sessionItem.user) === null || _this_sessionItem_user === void 0 ? void 0 : (_this_sessionItem_user_ids = _this_sessionItem_user.ids) === null || _this_sessionItem_user_ids === void 0 ? void 0 : (_this_sessionItem_user_ids_conviva = _this_sessionItem_user_ids.conviva) === null || _this_sessionItem_user_ids_conviva === void 0 ? void 0 : _this_sessionItem_user_ids_conviva.profileid;
            }
        },
        {
            key: "getContentTypeSpecificTags",
            value: function getContentTypeSpecificTags(adaptedMetadata) {
                var contentDescriptor = this.getContentDescriptor();
                switch(contentDescriptor){
                    case ContentDescriptorEnum.Linear:
                    case ContentDescriptorEnum.Sle:
                        {
                            var liveMetadata = adaptedMetadata;
                            return this.getLiveCustomTags(liveMetadata);
                        }
                    case ContentDescriptorEnum.Fer:
                    case ContentDescriptorEnum.NonEpisodicVod:
                    case ContentDescriptorEnum.ShortForm:
                    case ContentDescriptorEnum.Trailer:
                        {
                            var vodMetadata = adaptedMetadata;
                            return this.getVodCustomTags(vodMetadata);
                        }
                    case ContentDescriptorEnum.EpisodicVod:
                        {
                            var vodEpisodicMetadata = adaptedMetadata;
                            return this.getEntertainmentCustomTags(vodEpisodicMetadata);
                        }
                    default:
                        return {};
                }
            }
        },
        {
            key: "getAssetEncodingTag",
            value: function getAssetEncodingTag1() {
                return getAssetEncodingTag(this.playoutData.stream);
            }
        },
        {
            key: "mapPrefetchStageToReportingTags",
            value: function mapPrefetchStageToReportingTags(prefetchStage) {
                switch(prefetchStage){
                    case VideoStartupStates.EngineStarted:
                        this.logger.verbose("Prefetch Stage set to: ".concat(ReportingPrefetchStage.EngineIdle));
                        return ReportingPrefetchStage.EngineIdle;
                    case VideoStartupStates.AdsInsertionCalled:
                        this.logger.verbose("Prefetch Stage set to: ".concat(ReportingPrefetchStage.AdInitComplete));
                        return ReportingPrefetchStage.AdInitComplete;
                    case VideoStartupStates.AdsBootstrapped:
                    case VideoStartupStates.VamCalled:
                        this.logger.verbose("Prefetch Stage set to: ".concat(ReportingPrefetchStage.VamComplete));
                        return ReportingPrefetchStage.VamComplete;
                    case VideoStartupStates.AdvertsInitialised:
                    case VideoStartupStates.VideoProviderCalled:
                        this.logger.verbose("Prefetch Stage set to: ".concat(ReportingPrefetchStage.VideoProviderComplete));
                        return ReportingPrefetchStage.VideoProviderComplete;
                    default:
                        this.logger.verbose("Prefetch Stage set to: ".concat(ReportingPrefetchStage.NotApplicable));
                        return ReportingPrefetchStage.NotApplicable;
                }
            }
        },
        {
            key: "getAbTestingVariant",
            value: function getAbTestingVariant() {
                var _this_sessionItem_reporting;
                return (_this_sessionItem_reporting = this.sessionItem.reporting) === null || _this_sessionItem_reporting === void 0 ? void 0 : _this_sessionItem_reporting.experiments;
            }
        },
        {
            key: "getSessionTrackingId",
            value: function getSessionTrackingId() {
                return this.sessionItem.sessionId;
            }
        },
        {
            key: "getOptedOutSdks",
            value: function getOptedOutSdks() {
                var _this_sessionItem_addons, _this_sessionItem_addons_optedOutSdks, _this_sessionItem_addons1, _this_sessionItem_addons2;
                if (!((_this_sessionItem_addons = this.sessionItem.addons) === null || _this_sessionItem_addons === void 0 ? void 0 : _this_sessionItem_addons.optedOutSdks) || ((_this_sessionItem_addons1 = this.sessionItem.addons) === null || _this_sessionItem_addons1 === void 0 ? void 0 : (_this_sessionItem_addons_optedOutSdks = _this_sessionItem_addons1.optedOutSdks) === null || _this_sessionItem_addons_optedOutSdks === void 0 ? void 0 : _this_sessionItem_addons_optedOutSdks.length) === 0) {
                    return 'NA';
                }
                return (_this_sessionItem_addons2 = this.sessionItem.addons) === null || _this_sessionItem_addons2 === void 0 ? void 0 : _this_sessionItem_addons2.optedOutSdks.sort(function(a, b) {
                    return a.localeCompare(b);
                }).join(' | ');
            }
        },
        {
            key: "getContentDescriptor",
            value: function getContentDescriptor1() {
                return getContentDescriptor(this.sessionItem, this.playoutData);
            }
        }
    ]);
    return ConvivaTagsProvider;
}();

//# sourceMappingURL=conviva-tags-provider.js.map